import { render, staticRenderFns } from "./custom-cut.vue?vue&type=template&id=5aa5507a&"
import script from "./custom-cut.vue?vue&type=script&lang=ts&"
export * from "./custom-cut.vue?vue&type=script&lang=ts&"
import style0 from "./custom-cut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports